// extracted by mini-css-extract-plugin
export var amount = "FlightCard-module--amount--155ee";
export var contentContainer = "FlightCard-module--contentContainer--76f71";
export var flightCard = "FlightCard-module--flightCard--5e3af";
export var flightCardLink = "FlightCard-module--flightCardLink--a8542";
export var heading = "FlightCard-module--heading--5a418";
export var price = "FlightCard-module--price--c9676";
export var priceTaxes = "FlightCard-module--priceTaxes--815c8";
export var subheading = "FlightCard-module--subheading--465ad";